import { useMemo } from 'react';
import { ExtrudeGeometry } from 'three';
import { squareTubeProfile } from './crossSections';
import { SCALE_IN_TO_UNIT } from '../types';
import { MATERIALS } from '../materials';
import { useSceneSelection } from '../selection/useSceneSelection';

interface Props {
  lengthIn: number;
  position: [number, number, number];
  rotation: [number, number, number];
  partNumber?: string;
  stockLengthIn?: number;
  refId: string;
  /** Visual-only cross-section scale (default 3 for visibility on large ramps).
   *  Does NOT affect BOM dimensions — partNumber + lengthIn still report real specs. */
  visualScale?: number;
}

export function RailTopTube({
  lengthIn,
  position,
  rotation,
  partNumber = 'MTC120125125',
  stockLengthIn,
  refId,
  visualScale = 3,
}: Props) {
  const geometry = useMemo(() => {
    const g = new ExtrudeGeometry(squareTubeProfile(), { depth: lengthIn, bevelEnabled: false });
    g.translate(0, 0, -lengthIn / 2);
    // Scale cross-section (X,Y) by visualScale for visibility, length (Z) by 1×SCALE
    g.scale(SCALE_IN_TO_UNIT * visualScale, SCALE_IN_TO_UNIT * visualScale, SCALE_IN_TO_UNIT);
    return g;
  }, [lengthIn, visualScale]);

  const isCut = stockLengthIn !== undefined && stockLengthIn !== lengthIn;

  return (
    <mesh
      geometry={geometry}
      material={MATERIALS.aluminumBrushed}
      position={position}
      rotation={rotation}
      castShadow
      receiveShadow
      userData={{
        partNumber,
        kind: 'rail',
        lengthIn,
        cutOnSite: isCut,
        stockLengthIn,
        refId,
      }}
      onPointerOver={(e) => {
        e.stopPropagation();
        useSceneSelection.getState().setHovered(refId);
      }}
      onPointerOut={(e) => {
        e.stopPropagation();
        useSceneSelection.getState().setHovered(null);
      }}
      onPointerDown={(e) => {
        e.stopPropagation();
        useSceneSelection.getState().setSelected(refId);
      }}
    />
  );
}
